import PropTypes from 'prop-types'
import { Navigate, useLocation } from 'react-router-dom'
import Loading from '../Components/Layers/Loading'
import { useAuth } from '../Contexts/AuthContext'

const ProtectedRoute = ({ children, requiredPermission, requiredRole, requiredModule }) => {
  const { isAuthenticated, hasPermission, hasModule, user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return <Loading />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (requiredRole) {
    const userRole = user?.Role?.name || user?.role
    if (userRole !== requiredRole) {
      return <Navigate to="/unauthorized" replace />
    }
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/unauthorized" replace />
  }

  if (requiredModule && !hasModule(requiredModule)) {
    return <Navigate to="/unauthorized" replace />
  }

  return children
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  requiredPermission: PropTypes.string,
  requiredRole: PropTypes.string,
  requiredModule: PropTypes.string,
}

export default ProtectedRoute
